(() => {
  function init(root) {
    if (root.dataset.feedbackInitialized === 'true') return;
    root.dataset.feedbackInitialized = 'true';

    const panel = root.querySelector('.velisse-feedback__panel');
    const cover = root.querySelector('[data-feedback-cover]');
    const experience = root.querySelector('[data-feedback-experience]');
    const form = root.querySelector('[data-feedback-form]');
    const steps = Array.from(root.querySelectorAll('[data-feedback-step]'));
    const progress = root.querySelector('[data-feedback-progress]');
    const progressFill = root.querySelector('[data-feedback-progress-fill]');
    const start = root.querySelector('[data-feedback-start]');
    const close = root.querySelector('[data-feedback-close]');
    const back = root.querySelector('[data-feedback-back]');
    const next = root.querySelector('[data-feedback-next]');
    const actions = root.querySelector('[data-feedback-actions]');
    const complete = root.querySelector('[data-feedback-complete]');
    const restart = root.querySelector('[data-feedback-restart]');
    const answers = {};
    let current = 0;
    let transitioning = false;

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function setFullscreen(enabled) {
      panel.classList.toggle('is-fullscreen', enabled && isMobile());
      document.body.classList.toggle('velisse-feedback-open', enabled && isMobile());
    }

    function updateProgress() {
      const total = Math.max(steps.length, 1);
      const position = Math.min(current + 1, total);
      progress.setAttribute('aria-valuenow', String(position));
      progressFill.style.width = `${(position / total) * 100}%`;
      back.hidden = current === 0;
      next.textContent = current === steps.length - 1 ? 'Finalizar →' : 'Continuar →';
    }

    function renderStars(step, value) {
      const status = step.querySelector('[data-feedback-rating-status]');
      step.querySelectorAll('[data-feedback-star]').forEach((star) => {
        const active = Number(star.dataset.value) <= value;
        const selected = Number(star.dataset.value) === value;
        star.classList.toggle('is-active', active);
        star.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (status) status.textContent = value ? `${value} de 5 estrellas` : '';
    }

    function syncStep(step) {
      const key = step.dataset.productKey;
      const stored = answers[key];
      if (step.dataset.stepType === 'rating') renderStars(step, stored?.rating || 0);
      const comment = step.querySelector('[data-feedback-comment]');
      if (comment) comment.value = stored?.comment || '';
      step.querySelector('[data-feedback-error]')?.classList.remove('is-visible');
    }

    function renderStep(index, direction) {
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== index;
        step.classList.remove('is-active', 'is-leaving-forward', 'is-leaving-back', 'is-entering-forward', 'is-entering-back', 'is-invalid');
      });
      current = index;
      const step = steps[current];
      syncStep(step);
      step.hidden = false;
      step.classList.add('is-active');
      if (direction) step.classList.add(`is-entering-${direction}`);
      updateProgress();
      requestAnimationFrame(() => {
        const target = step.querySelector('[data-feedback-star], [data-feedback-comment]');
        target?.focus({ preventScroll: true });
      });
    }

    function showStep(index, direction = 'forward') {
      if (transitioning || index < 0 || index >= steps.length || index === current) return;
      transitioning = true;
      const previous = steps[current];
      previous.classList.add(`is-leaving-${direction}`);
      window.setTimeout(() => {
        renderStep(index, direction);
        window.setTimeout(() => {
          steps[current].classList.remove(`is-entering-${direction}`);
          transitioning = false;
        }, 450);
      }, 190);
    }

    function validate(step) {
      if (step.dataset.stepType !== 'rating') return true;
      const key = step.dataset.productKey;
      const valid = Boolean(answers[key]?.rating);
      const error = step.querySelector('[data-feedback-error]');
      error?.classList.toggle('is-visible', !valid);
      if (!valid) {
        step.classList.remove('is-invalid');
        void step.offsetWidth;
        step.classList.add('is-invalid');
      }
      return valid;
    }

    start.addEventListener('click', () => {
      cover.classList.add('is-leaving');
      window.setTimeout(() => {
        cover.hidden = true;
        cover.classList.remove('is-leaving');
        experience.hidden = false;
        experience.classList.add('is-entering');
        setFullscreen(true);
        renderStep(0, '');
        window.setTimeout(() => experience.classList.remove('is-entering'), 470);
      }, 260);
    });

    close.addEventListener('click', () => {
      setFullscreen(false);
      panel.scrollTop = 0;
    });

    root.querySelectorAll('[data-feedback-star]').forEach((star) => {
      star.addEventListener('click', () => {
        const step = star.closest('[data-feedback-step]');
        const key = step.dataset.productKey;
        const rating = Number(star.dataset.value);
        answers[key] = { ...(answers[key] || {}), rating };
        renderStars(step, rating);
        step.querySelector('[data-feedback-error]')?.classList.remove('is-visible');
      });

      star.addEventListener('mouseenter', () => {
        const step = star.closest('[data-feedback-step]');
        step.querySelectorAll('[data-feedback-star]').forEach((item) => item.classList.toggle('is-active', Number(item.dataset.value) <= Number(star.dataset.value)));
      });

      star.addEventListener('mouseleave', () => {
        const step = star.closest('[data-feedback-step]');
        renderStars(step, answers[step.dataset.productKey]?.rating || 0);
      });
    });

    root.querySelectorAll('[data-feedback-comment]').forEach((comment) => {
      comment.addEventListener('input', () => {
        const step = comment.closest('[data-feedback-step]');
        const key = step.dataset.productKey;
        answers[key] = { ...(answers[key] || {}), comment: comment.value.slice(0, 600) };
      });
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const step = steps[current];
      const comment = step.querySelector('[data-feedback-comment]');
      const key = step.dataset.productKey;
      if (comment) answers[key] = { ...(answers[key] || {}), comment: comment.value.trim() };
      if (!validate(step)) return;
      if (current < steps.length - 1) {
        showStep(current + 1);
        return;
      }
      form.hidden = true;
      progress.hidden = true;
      actions.hidden = true;
      complete.hidden = false;
      complete.classList.add('is-entering');
      window.setTimeout(() => complete.classList.remove('is-entering'), 470);
    });

    back.addEventListener('click', () => showStep(current - 1, 'back'));

    restart.addEventListener('click', () => {
      complete.hidden = true;
      form.hidden = false;
      progress.hidden = false;
      actions.hidden = false;
      renderStep(0, 'back');
    });

    window.addEventListener('resize', () => {
      if (!experience.hidden) setFullscreen(true);
    });

    if (steps.length) renderStep(0, '');
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-velisse-feedback]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
